import { createFileRoute } from "@tanstack/react-router";
import { WidgetAuthProvider } from "src/components/Widget/WidgetAuthProvider";
import { WidgetChatCustom } from "src/components/Widget/WidgetChatCustom";

export const Route = createFileRoute("/widget/chat")({
    component: WidgetChatRoute,
});

function WidgetChatRoute() {
    // Get auth parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const authMode = urlParams.get("auth") || "popup";
    const loginHint = urlParams.get("loginHint") || undefined;
    const sid = urlParams.get("sid") || undefined;

    return (
        <WidgetAuthProvider
            authMode={authMode as "popup" | "sso" | "inherit"}
            loginHint={loginHint}
            sid={sid}
        >
            <WidgetChatCustom />
        </WidgetAuthProvider>
    );
}
